/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  NavLink,
  withRouter,
  useHistory,
  useLocation,
  Link,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { imageUrls } from "../../constants/images";
import { Icon } from "@iconify/react";
import InsideSearchIcon1 from "../../../assets/InsideSearchIcon1";
import InsideSearchIcon2 from "../../../assets/InsideSearchIcon2";
import { getProfileSession } from "../../redux/actions/dbactions/profileActions";
import { toast } from "react-toastify";
import "./sidebar.scss";
import { MdKeyboardArrowUp } from "react-icons/md";
import { RiArrowDownSLine } from "react-icons/ri";

const Sidebar = ({
  handleShow,
  show,
  mobile,
  hideMobile,
  navigationLinks,
  searchQuery,
  setSearchQuery,
  setMobile,
}) => {
  const { profileData } = getProfileSession();
  const [showNoprofileMsg, setShowNoprofileMsg] = useState(true);
  const [isShowPayout, setIsShowPayout] = useState(false);
  const { profile } = useSelector((state) => state.profileReducer);
  const history = useHistory();
  const location = useLocation();

  // Manage hover state for each menu item

  useEffect(() => {
    if (profileData) {
      if (
        profileData.user_has_profile_yn !== "Y" &&
        location.pathname !== "/dashboard/profile" &&
        showNoprofileMsg
      ) {
        toast.dismiss();
        toast.error("Please fill your profile first");
        history.push("/dashboard/profile");
        window.location.reload(); // Refresh the page
      }
    } else {
      if (location.pathname !== "/dashboard/profile" && showNoprofileMsg) {
        history.push("/dashboard/profile");
        setShowNoprofileMsg(false);
      }
    }
  }, [
    profile,
    JSON.stringify(profileData),
    location.pathname,
    history,
    showNoprofileMsg,
  ]);

  const handleNavLinkClick = (e, url) => {
    if (
      profileData.user_has_profile_yn !== "Y" &&
      url !== "/dashboard/profile"
    ) {
      e.preventDefault();
      toast.dismiss();
      toast.error("Please fill your profile first to access other pages");
    } else {
      setMobile(!mobile);
    }
  };

  return (
    <div
      className={`side_nav z-[55] flex justify-between flex-col sidebarIn ${
        mobile && "sidebarOut"
      } `}
    >
      <div style={{ height: "100%" }}>
        <div className="nav_side flex items-center justify-between border-b border-[#E7E7E9]">
          <Link to={"/dashboard"} onClick={handleNavLinkClick}>
            <div className="w-40">
              <img
                src={imageUrls.logo}
                style={{ mixBlendMode: "darken" }}
                alt="logo"
              />
            </div>
          </Link>
          <div className="mobile_dev close_position">
            <Icon
              icon="system-uicons:cross"
              className="cursor-pointer"
              onClick={hideMobile}
            />
          </div>
        </div>
        <div className="my-4 flex items-center px-3">
          <form
            className="px-3 py-2 flex gap-2 h-8 rounded-md text-sm w-full border border-[##E1E1E1] bg-[#FAFAFB] text-[#4A4E5A] search"
            onSubmit={(e) => e.preventDefault()}
          >
            <Icon
              icon="iconamoon:search-thin"
              style={{ width: "20px", height: "15px" }}
            />
            <input
              type="text"
              placeholder="Search"
              className="w-full bg-transparent border-0 outline-0"
              autoFocus
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div>
              <InsideSearchIcon1 />
            </div>
            <div>
              <InsideSearchIcon2 />
            </div>
          </form>
        </div>
        <ul className="navigation-links">
          {navigationLinks.map((item, index) =>
            item.event ? (
              <li
                className="logout navigation-links_navLinks"
                key={item.id}
                onClick={handleShow}
              >
                <span>{item.icon}</span>
                <span>{item.title}</span>
              </li>
            ) : item.heading === "" ? (
              <NavLink
                to={item.url}
                key={item.id}
                exact
                onClick={(e) => handleNavLinkClick(e, item.url)}
                className="navigation-links_navLinks"
                style={{ position: "relative" }}
              >
                <li>
                  <span>{item.icon}</span>
                  <span>{item.title}</span>
                </li>
              </NavLink>
            ) : item.heading === "PAYMENTS" ? (
              <React.Fragment key={item.id}>
                {item.title === "Payout" && (
                  <div className="font-medium text-xs text-[#7A7A87] pl-4 mt-4 mb-2 navigation-links_subHeading">
                    <span>PAYMENTS</span>
                  </div>
                )}
                <NavLink
                  to={item.url}
                  key={item.id}
                  exact
                  onClick={(e) => handleNavLinkClick(e, item.url)}
                  className="navigation-links_navLinks"
                  style={{ position: "relative" }}
                >
                  <li className=" w-full">
                    <span>{item.icon}</span>
                    <span
                      onClick={() =>
                        item?.title === "Payout"
                          ? setIsShowPayout(!isShowPayout)
                          : ""
                      }
                    >
                      {item.title}{" "}
                    </span>
                    {item?.title === "Payout" && (
                      <div
                        onClick={() =>
                          item?.title === "Payout"
                            ? setIsShowPayout(!isShowPayout)
                            : ""
                        }
                        className="flex w-full justify-end"
                      >
                        {isShowPayout ? (
                          <MdKeyboardArrowUp />
                        ) : (
                          <RiArrowDownSLine />
                        )}
                      </div>
                    )}
                  </li>
                </NavLink>
                {isShowPayout && (
                  <div className="mx-3 w-full">
                    {item.title === "Payout" && item.submenu && (
                      <ul className=" w-[90%]">
                        {item.submenu.map((sublink) => (
                          <NavLink to={sublink.url} key={sublink.id}>
                            <li>
                              <span>{sublink.icon} </span>
                              <span>{sublink.title}</span>
                            </li>
                          </NavLink>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment key={item.id}>
                {item.title === "Messages" && (
                  <div className="font-medium text-xs text-[#7A7A87] pl-4 navigation-links_subHeading mb-2">
                    <span>OTHERS</span>
                  </div>
                )}
                <NavLink
                  to={item.url}
                  key={item.id}
                  exact
                  onClick={(e) => handleNavLinkClick(e, item.url)}
                  className="navigation-links_navLinks"
                  style={{ position: "relative" }}
                >
                  <li>
                    <span>{item.icon}</span>
                    <span>{item.title}</span>
                  </li>
                </NavLink>
              </React.Fragment>
            )
          )}
        </ul>
      </div>
    </div>
  );
};

export default withRouter(Sidebar);
